import type { ColorTag } from "@color-finder/color-finder-api/models";
import WarningAmberSharpIcon from "@mui/icons-material/WarningAmberSharp";
import { Tooltip, Typography } from "@mui/material";
import type { FC } from "react";
import { restrictionsText } from "./restrictions-banner";

export const RestrictionsIcon: FC<{ value: Array<ColorTag> }> = ({ value }) => {
  if (!value.length) return null;
  return (
    <Tooltip
      title={
        <>
          <Typography fontSize="1.1em" fontWeight={500}>
            {restrictionsText}
          </Typography>
          {value.map((v) => (
            <Typography key={v.value} fontSize="1em">
              {v.description}
            </Typography>
          ))}
        </>
      }
    >
      <WarningAmberSharpIcon color="warning" />
    </Tooltip>
  );
};
